// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import objectiveProjectEntity from './entities/objective-project.json';
import objectiveProjectMenu from '../pages/objective-project/menu.json';
import objectiveProjectFullForm from '../pages/objective-project/forms/full.json';
import objectiveProjectContextForm from '../pages/objective-project/forms/context.json';
import objectiveProjectMiniForm from '../pages/objective-project/forms/mini.json';
import objectiveProjectLookupForm from '../pages/objective-project/forms/lookup.json';
import objectiveProjectTableView from '../pages/objective-project/views/table.json';
import objectiveProjectCardsView from '../pages/objective-project/views/cards.json';
import objectiveProjectDashboardView from '../pages/objective-project/views/dashboard.json';

/** Тип запису «Проєкт цілі» зі сторінками пакета: меню, форми та подання з pages/objective-project/. */
export const objectiveProjectDefinition: IRecordTypeDefinition = {
  ...objectiveProjectEntity,
  views: assembleViewSet({
      table: objectiveProjectTableView,
      cards: objectiveProjectCardsView,
      dashboard: objectiveProjectDashboardView,
  }),
  form: objectiveProjectFullForm,
  forms: { full: objectiveProjectFullForm, context: objectiveProjectContextForm, mini: objectiveProjectMiniForm, lookup: objectiveProjectLookupForm },
  menu: objectiveProjectMenu,
} as IRecordTypeDefinition;
